import { AddTerminalDto } from "./addTerminalDto";
import { EditTerminalDto } from "./editTerminalDto";
import { TerminalDetailsDto } from "./terminalDetailsDto";

export interface EditTerminalFormDto {
  id?: number;
  name: string;
  number: string;
  address: string;
  latitude?: number;
  longitude?: number;
  hardwareId?: string;
  description: string;
  companyIds: number[];
  isNotActive: boolean;
  // ERP/НИИАТ fields
  aisErpId?: string | null;
  isNiiatIntegrationEnabled?: boolean;
  terminalTypeId?: number | null;
  useTypeId?: number | null;
  checkupCertificateNumber?: string | null;
  checkupCertificateDate?: string | null;
}

export const emptyEditTerminalFormDto = (companyId?: number): EditTerminalFormDto => {
  return {
    name: '',
    number: '',
    address: '',
    latitude: undefined,
    longitude: undefined,
    hardwareId: '',
    description: '',
    companyIds: companyId ? [companyId] : [],
    isNotActive: false,
    // ERP/НИИАТ fields
    aisErpId: '',
    isNiiatIntegrationEnabled: false,
    terminalTypeId: null,
    useTypeId: null,
    checkupCertificateNumber: '',
    checkupCertificateDate: null,
  }
};

export const mapToAddTerminalDto = (formData: EditTerminalFormDto): AddTerminalDto => {
  return {
    name: formData.name,
    number: formData.number,
    address: formData.address,
    latitude: formData.latitude || undefined,
    longitude: formData.longitude || undefined,
    hardwareId: formData.hardwareId!,
    description: formData.description,
    companyIds: formData.companyIds,
    isActive: !formData.isNotActive,
    aisErpId: formData.aisErpId
  }
};

export const mapToEditTerminalDto = (formData: EditTerminalFormDto): EditTerminalDto => {
  return {
    id: formData.id!,
    name: formData.name,
    number: formData.number,
    address: formData.address,
    latitude: formData.latitude || undefined,
    longitude: formData.longitude || undefined,
    hardwareId: formData.hardwareId,
    description: formData.description,
    companyIds: formData.companyIds,
    isActive: !formData.isNotActive,
    erpInfo: {
      aisErpId: formData.aisErpId,
      terminalTypeId: formData.terminalTypeId,
      useTypeId: formData.useTypeId,
      checkupCertificateNumber: formData.checkupCertificateNumber,
      checkupCertificateDate: formData.checkupCertificateDate,
    },
  }
};

export const mapToEditTerminalFormDto = (dto: TerminalDetailsDto): EditTerminalFormDto => {
  return {
    id: dto.id,
    name: dto.name,
    number: dto.number,
    address: dto.address,
    latitude: dto.latitude,
    longitude: dto.longitude,
    hardwareId: dto.hardwareId,
    description: dto.description,
    companyIds: dto.companies ? dto.companies.map(d => d.id) : [],
    isNotActive: !dto.isActive,
    aisErpId: dto.erpInfo?.aisErpId ?? '',
    isNiiatIntegrationEnabled: dto.isNiiatIntegrationEnabled ?? false,
    terminalTypeId: dto.erpInfo?.terminalTypeId ?? null,
    useTypeId: dto.erpInfo?.useTypeId ?? null,
    checkupCertificateNumber: dto.erpInfo?.checkupCertificateNumber ?? '',
    checkupCertificateDate: dto.erpInfo?.checkupCertificateDate ?? null,
  }
};
